import LoadingScreen from './LoadingScreen.component';

export default LoadingScreen;
